import mapboxgl from 'mapbox-gl'

export default {
    props: {
        showFullscreen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fullscreenControl: null,
        }
    },
    methods: {
        handleFullscreen() {
            if (!this.fullscreenControl) {
                this.fullscreenControl = new mapboxgl.FullscreenControl({
                    container: document.querySelector('.map_content')
                })
            }
            if (this.showFullscreen) {
                this.mySmartMap.addControl(this.fullscreenControl)
            } else if (this.mySmartMap.hasControl(this.fullscreenControl)) {
                this.mySmartMap.removeControl(this.fullscreenControl)
            }
        }
    },
    watch: {
        showFullscreen() {
            this.handleFullscreen()
        }
    }
}